export default __webpack_public_path__ + "static/media/@paulynhasaless.f0700a80.jpg";